import { HttpClient } from '@angular/common/http';
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { FolderService } from '@app/shared/common-folder-structure/service/folder.service';
import { OpenAIService } from '@app/shared/services/openai.service';
var AIPromptComponent = /** @class */ (function () {
    function AIPromptComponent(openaiService, http, folderService) {
        this.openaiService = openaiService;
        this.http = http;
        this.folderService = folderService;
        this.promptText = '';
        this.aiLoad = false;
        this.emailBody = '';
        this.cancelEmit = new EventEmitter();
        this.insertMailEmit = new EventEmitter();
        this.showToneOptions = false;
        this.showRewriteOptions = false;
        this.selectedToneOptions = [];
        this.selectedRewriteOptions = [];
        this.contentBody = '';
        this.toneOptions = [
            { label: 'Make it sound professional', checked: false },
            { label: 'Make it casual', checked: false }
        ];
        this.rewriteOptions = [
            { label: 'Make it shorter', checked: false },
            { label: 'Make it longer', checked: false },
            { label: 'Break into bullet points', checked: false },
            { label: 'Simplify', checked: false }
        ];
    }
    AIPromptComponent.prototype.ngOnInit = function () {
    };
    AIPromptComponent.prototype.ngOnChanges = function () {
        this.promptInput.nativeElement.focus();
    };
    AIPromptComponent.prototype.generatePrompt = function (type) {
        var _this = this;
        this.aiLoad = true;
        var notes = '';
        if (this.selectedTexts || type != undefined) {
            this.selectedTexts = type;
            notes = this.selectedTexts;
            this.updateOptionCheckboxesFromSelectedText(notes);
            // this.promptText = notes;
        }
        else {
            notes = this.promptText;
        }
        var data = {
            prompt: notes,
            footer: this.footerMessage,
            body: this.mailContent,
            screenType: this.screenType,
            use_openai: false,
            tablePkId: this.emailHandleTagData['tablePKId'],
            recreate: type != undefined ? true : false
        };
        this.aiSubscription = this.openaiService.generateText(data).subscribe(function (res) {
            _this.emailHandleTagData['subject'] = res['subject'];
            _this.emailHandleTagData['message'] = res['body'];
            var body = _this.replaceTags(res['body'], _this.tags);
            // this.folderService.getReplacedMessage(this.emailHandleTagData).subscribe((value: any) => {
            //     if (data) {
            _this.aiLoad = false;
            _this.emailSubject = res['subject'];
            _this.selectedTexts = '';
            _this.contentBody = _this.formatcontentBody(body);
            //     }
            // })
        });
    };
    AIPromptComponent.prototype.updateOptionCheckboxesFromSelectedText = function (selectedText) {
        var selectedLabels = selectedText.split(',').map(function (s) { return s.trim(); });
        this.rewriteOptions.forEach(function (option) {
            option.checked = selectedLabels.includes(option.label);
        });
        this.toneOptions.forEach(function (option) {
            option.checked = selectedLabels.includes(option.label);
        });
    };
    AIPromptComponent.prototype.formatEmailBody = function (emailBody) {
        emailBody = emailBody.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        emailBody = emailBody.replace(/(?:^|\n)\* (.+)/g, '<li>$1</li>');
        emailBody = emailBody.replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>');
        emailBody = emailBody.replace(/^<p><br>/, '<p>');
        emailBody = emailBody.replace(/<br><br>/g, '</p><p>');
        if (!emailBody.startsWith('<p>')) {
            emailBody = '<p>' + emailBody;
        }
        if (!emailBody.endsWith('</p>')) {
            emailBody = emailBody + '</p>';
        }
        return emailBody;
    };
    AIPromptComponent.prototype.stopLoad = function () {
        this.aiLoad = false;
        if (this.aiSubscription) {
            this.aiSubscription.unsubscribe();
        }
    };
    AIPromptComponent.prototype.insertMail = function () {
        this.selectedToneOptions = this.toneOptions.filter(function (opt) { return opt.checked; }).map(function (opt) { return opt.label; });
        this.selectedRewriteOptions = this.rewriteOptions.filter(function (opt) { return opt.checked; }).map(function (opt) { return opt.label; });
        this.insertMailEmit.emit({
            subject: this.emailSubject,
            body: this.contentBody.replace(/<\/p>/g, '</p><br>'),
            prompt: this.promptText,
            tone: this.selectedToneOptions,
            rewrite: this.selectedRewriteOptions
        });
        this.closePanel();
    };
    AIPromptComponent.prototype.closePanel = function () {
        this.aiLoad = false;
        this.promptText = '';
        this.contentBody = '';
        this.emailSubject = '';
        this.showToneOptions = false;
        this.showRewriteOptions = false;
        this.toneOptions.forEach(function (opt) { return opt.checked = false; });
        this.selectedToneOptions = [];
        this.rewriteOptions.forEach(function (opt) { return opt.checked = false; });
        this.selectedRewriteOptions = [];
        this.cancelEmit.emit();
    };
    AIPromptComponent.prototype.getPrompt = function (prompt) {
        this.promptText = prompt;
    };
    AIPromptComponent.prototype.applyOptions = function (type) {
        this.selectedToneOptions = this.toneOptions.filter(function (opt) { return opt.checked; }).map(function (opt) { return opt.label; });
        this.selectedRewriteOptions = this.rewriteOptions.filter(function (opt) { return opt.checked; }).map(function (opt) { return opt.label; });
        var combinedText = this.selectedToneOptions.concat(this.selectedRewriteOptions).join(', ');
        this.generatePrompt(combinedText);
        if (type == 'rewrite') {
            this.showRewriteOptions = false;
        }
        else {
            this.showToneOptions = false;
        }
    };
    AIPromptComponent.prototype.toggleDropdown = function (type) {
        if (type === 'tone') {
            this.showToneOptions = !this.showToneOptions;
            this.showRewriteOptions = false;
        }
        else {
            this.showRewriteOptions = !this.showRewriteOptions;
            this.showToneOptions = false;
        }
    };
    AIPromptComponent.prototype.hasCheckedRewriteOptions = function () {
        return this.rewriteOptions.some(function (opt) { return opt.checked; });
    };
    AIPromptComponent.prototype.hasCheckedToneOptions = function () {
        return this.toneOptions.some(function (opt) { return opt.checked; });
    };
    AIPromptComponent.prototype.onClickOutside = function (event) {
        var target = event.target;
        if (this.toneDropdownRef) {
            var clickedTone = this.toneDropdownRef.nativeElement.contains(target);
            if (!clickedTone)
                this.showToneOptions = false;
        }
        if (this.rewriteDropdownRef) {
            var clickedRewrite = this.rewriteDropdownRef.nativeElement.contains(target);
            if (!clickedRewrite)
                this.showRewriteOptions = false;
        }
    };
    AIPromptComponent.prototype.replaceTags = function (template, tags) {
        return tags.find.reduce(function (result, tag, i) {
            var replacement = tags.replace[i] || "";
            var tagWithBrackets = tag.startsWith("[") && tag.endsWith("]") ? tag : "[" + tag + "]";
            var tagKey = tagWithBrackets.slice(1, -1);
            var nameKey;
            if (replacement.includes("%s")) {
                if (tagKey == 'statement_portal_url') {
                    nameKey = "portal_link" + "_name";
                }
                else if (tagKey == 'proposal_portal_url') {
                    nameKey = "proposal_portal_link" + "_name";
                }
                else if (tagKey == "upload_media_portal_url") {
                    nameKey = "upload_media_portal_link" + "_name";
                }
                else if (tagKey == "view_media_portal_url") {
                    nameKey = "view_media_portal_link" + "_name";
                }
                else {
                    nameKey = tagKey + "_name";
                }
                var nameIndex = tags.find.findIndex(function (t) { return t === "[" + nameKey + "]" || t === nameKey; });
                var nameValue = nameIndex >= 0 ? tags.replace[nameIndex] || "" : "";
                if (!nameValue && i + 1 < tags.replace.length) {
                    nameValue = tags.replace[i + 1] || "";
                }
                replacement = replacement.replace("%s", nameValue);
            }
            var escapedTag = tagWithBrackets.replace(/[[\]]/g, "\\$&");
            var regex = new RegExp(escapedTag, "g");
            return result.replace(regex, replacement);
        }, template);
    };
    AIPromptComponent.prototype.formatcontentBody = function (contentBody) {
        contentBody = contentBody.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        contentBody = contentBody.replace(/(?:^|\n)\* (.+)/g, '<li>$1</li>');
        contentBody = contentBody.replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>');
        contentBody = contentBody.replace(/^<p><br>/, '<p>');
        contentBody = contentBody.replace(/<br><br>/g, '</p><p>');
        if (!contentBody.startsWith('<p>')) {
            contentBody = '<p>' + contentBody;
        }
        if (!contentBody.endsWith('</p>')) {
            contentBody = contentBody + '</p>';
        }
        return contentBody;
    };
    return AIPromptComponent;
}());
export { AIPromptComponent };
